export default __webpack_public_path__ + "1.18.21/static/media/back-arrow.9e35e3eb.svg";